import React from 'react';
import connect from 'react-redux/es/connect/connect';
import {Select} from "antd";
import {setSingleUnitContract} from "../store/actions/unitcontracts";
import {withRouter} from "react-router-dom";

class UnitContractSelector extends React.Component {

    selectUnitContract = (id) => {
        const unitContracts = this.props.unitContracts.filter(uc => uc.id === id);
        if (unitContracts && unitContracts.length > 0) {
            //we found unit contract
            const current = this.props.location.pathname;
            this.props.dispatch(setSingleUnitContract(unitContracts[0].id, this.props.history, current));
        }
    };

    render() {
        if (this.props.failed) {
            return null;
        }
        return <div className="ant-breadcrumb top-bar--wrapper p-t-21 p-b-21 p-r-10" style={{textAlign: "right"}}>

			<span className={"m-r-10 top-bar--booking-indicator-text"}>
				Unit Contracts
			</span>

            {this.props.selectedId ?
                <Select defaultValue={this.props.selectedId}
                        style={{width: 180}}
                        onChange={this.selectUnitContract}>
                    {this.props.unitContracts.map(uc => {
                        return <Select.Option key={uc.id}
                                              value={uc.id}>{uc.name}</Select.Option>;
                    })
                    }
                </Select>
                :
                null
            }
        </div>;
    }
}

const mapStateToProps = state => {
    return {
        unitContracts: state.unitcontracts.availableUnitContracts,
        selectedId: state.unitcontracts.selectedUnitContractId,
        loading: state.unitcontracts.loading,
        failed: state.unitcontracts.failed
    };
};


export default withRouter(connect(mapStateToProps)(UnitContractSelector));
